import { getDicItemName as _getDicItemName, getLangDegraded as _getLangDegraded } from '@patsnap/synapse_common_utils'
import { I18nLang } from '../i18n'
import { IFieldLangMap, ILang } from '../types'

export function getFieldNameByLang(langMap: Partial<IFieldLangMap>, field: string | undefined, lang: I18nLang) {
  if (!field) {
    console.warn(`getFieldLangName: 字段值为空,忽略翻译,返回空值`)
    return ''
  }
  const fieldLangs = langMap[field]
  if (!fieldLangs) {
    console.error(`getFieldLangName: 没有找到${field}的语言配置,请检查`)
    return ''
  }
  return fieldLangs[lang]
}

/**
 * 更具当前语言自动降级的获取语言字段
 * @param data 含有name_cn,name_en的数据
 * @param lang I18nLang
 * @deprecated 请使用common包中的getLangDegraded
 * @returns string
 */
export const getLangDegraded = _getLangDegraded

export function getNameDegraded(data: { name_cn?: string; name_en?: string }, lang: I18nLang | ILang) {
  return _getLangDegraded(
    {
      display_name_cn: data.name_cn,
      display_name_en: data.name_en,
    },
    lang
  )
}

/**
 * 根据目标语言获取一个国际化的数据
 * @param data 含有lang字段的语言数据数组
 * @param field 文体字段
 * @param lang 目标语言
 * @param isDegraded 未匹配到目标语言的相关数据，是否降级查找其他语言
 * @returns
 */
export function getSpecialLang<T extends { lang: ILang }, P extends keyof T>(params: { data: T[]; field: P; lang: ILang; isDegraded?: boolean }) {
  const { data, field, lang, isDegraded = true } = params
  let nameDegradeChain: ILang[] = [lang]
  if (isDegraded) {
    nameDegradeChain = lang === 'CN' ? ['CN', 'EN'] : ['EN', 'CN']
  }
  for (const _lang of nameDegradeChain) {
    const rt = data.find((item) => item.lang === _lang && item[field])
    if (rt) {
      return rt[field]
    }
  }
  return undefined
}

/**
 * 根据目标语言获取匹配的国际化数组
 * @param params
 * @param params.data 含有lang字段的语言数据数组
 * @param params.field 文体字段
 * @param params.lang 目标语言
 * @param params.isDegraded 未匹配到目标语言的相关数据，是否降级查找其他语言
 * @returns
 */
export function getAllSpecialLang<T extends { lang: ILang }, P extends keyof T>(params: { data: T[]; field: P; lang: ILang; isDegraded?: boolean }) {
  const { data, field, lang, isDegraded = true } = params
  let nameDegradeChain: ILang[] = [lang]
  if (isDegraded) {
    nameDegradeChain = lang === 'CN' ? ['CN', 'EN'] : ['EN', 'CN']
  }

  for (const _lang of nameDegradeChain) {
    const rt = (data || []).filter((i) => i.lang === _lang && !!i[field]).map((i) => i[field])
    if (rt.length) {
      return rt
    }
  }
  return []
}

/**
 * @deprecated 请使用common包中的getDicItemName import { getDicItemName } from '@patsnap/synapse_common_utils'
 */
export const getDicItemName = _getDicItemName
